module.exports = __webpack_public_path__ + "img/no-record.9dba0928.png";